import { API } from '@config';
import { WorkOthersResidentTable } from '@src/types/WorkOthersResidential';

export const getWorkOthersResidential = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/residential-fn-p-work-others?populate=File&sort=id%3Adesc`, options);
  const data: WorkOthersResidentTable = await response.json();

  return data;
};
